import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BackendApi, localhost} from '../config/backend-api';

@Injectable({
  providedIn: 'root'
})
export class KeepAliveService {

  constructor(private httpClient: HttpClient) { }

  keepAlive() {
    const email = JSON.parse(localStorage.getItem('user')).email;
    return this.httpClient.post(localhost + BackendApi.KEEP_ALIVE, email, {responseType: 'text', observe: 'response'})
      .subscribe(d => {
        if (d.status === 200) {
          console.log('revived');
          const expirationTime = new Date().getTime() + 900000;
          // scadenza a 15 minuti dopo
          localStorage.setItem('expirationTime', JSON.stringify(expirationTime));
          localStorage.setItem('jwt', JSON.stringify(d.body));
        }
      }, error => {
        window.alert('Sessione scaduta');
        console.log(error);
        const token = localStorage.getItem('firebase-token');
        localStorage.clear();
        localStorage.setItem('firebase-token', token);
      }
    );
  }
}
